import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { getProduct } from '../../../apis/queries';
import Loader from '../../../components/Loader';
import { useHasAccess } from '../../../components/Sidebar';
import Header from '../../../widgets/Header';
import DetailNotFound from '../../DetailNotFound';
import ProductDetailForm from './ProductDetailForm';

const EditProductButton = ({
  isEditMode,
  isEditFormSubmitting,
  ...props
}: {
  isEditMode: boolean;
  isEditFormSubmitting: boolean;
  onClick: () => void;
}) => {
  return (
    <Button disabled={isEditFormSubmitting} {...props}>
      {' '}
      {isEditMode ? 'View Mode' : 'Edit Mode'}
    </Button>
  );
};

const ProductDetail = () => {
  const { id } = useParams();

  if (!id) {
    return <DetailNotFound />;
  }

  return <ProductDetailContent id={id} />;
};

const ProductDetailContent = ({ id }: { id: string }) => {
  const hasAccess = useHasAccess();
  const canEditProducts = hasAccess('editProducts');
  const PRODUCT_ID_QUERY_KEY = ['products', { id }];
  const { data, isLoading } = useQuery({ queryKey: PRODUCT_ID_QUERY_KEY, queryFn: () => getProduct(id) });
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditFormSubmitting, setEditFormSubmitting] = useState(false);

  const product = data?.data;

  if (isLoading) {
    return <Loader fullscreen />;
  }

  const onEditButtonClicked = () => {
    setIsEditMode(!isEditMode);
  };

  const onEditFormSubmit = (loading: boolean) => {
    setEditFormSubmitting(loading);
  };

  if (!product) {
    return <DetailNotFound />;
  }

  return (
    <div className="main-content">
      <Header
        title={product?.name}
        isDetailPage
        headerButton={
          canEditProducts ? (
            <EditProductButton
              isEditFormSubmitting={isEditFormSubmitting}
              isEditMode={isEditMode}
              onClick={onEditButtonClicked}
            />
          ) : (
            <></>
          )
        }
      />
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            <ProductDetailForm
              product={product}
              isEditMode={isEditMode}
              isEditFormSubmitting={isEditFormSubmitting}
              onEditFormSubmit={onEditFormSubmit}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductDetail;
